import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronContractMdVericalLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.5263 14.4179C11.8209 14.1777 12.2556 14.1952 12.5302 14.4697L16.5303 18.4697L16.582 18.5264C16.8223 18.8209 16.8049 19.2557 16.5303 19.5303C16.2557 19.8049 15.8209 19.8223 15.5264 19.582L15.4697 19.5303L12 16.0605L8.53022 19.5303C8.23733 19.8232 7.76256 19.8232 7.46967 19.5303C7.17689 19.2374 7.17682 18.7626 7.46967 18.4697L11.4697 14.4697L11.5263 14.4179ZM15.4697 4.46967C15.7626 4.17681 16.2374 4.17689 16.5303 4.46967C16.8232 4.76256 16.8232 5.23732 16.5303 5.53022L12.5302 9.53023C12.2373 9.82313 11.7626 9.82313 11.4697 9.53023L7.46967 5.53022L7.41791 5.47358C7.1777 5.179 7.1951 4.74423 7.46967 4.46967C7.74424 4.1951 8.179 4.1777 8.47358 4.41791L8.53022 4.46967L12 7.93941L15.4697 4.46967Z",
		fill: "currentColor"
	})
});
export default SvgChevronContractMdVericalLine;
